import { render } from "./SearchCustomers.vue?vue&type=template&id=8f55af2c&scoped=true"
import script from "./SearchCustomers.vue?vue&type=script&lang=js"
export * from "./SearchCustomers.vue?vue&type=script&lang=js"

import "./SearchCustomers.vue?vue&type=style&index=0&id=8f55af2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f55af2c"]])

export default __exports__